import { render } from "./AccountOrganizer.vue?vue&type=template&id=f38d710a"
import script from "./AccountOrganizer.vue?vue&type=script&lang=js"
export * from "./AccountOrganizer.vue?vue&type=script&lang=js"

import "./AccountOrganizer.vue?vue&type=style&index=0&id=f38d710a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__